import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "fileInput", "previewWrapper", "inputsWrapper", "thumbnailInput", "photoBox", "thumbnailHighlight"
  ]

  static values = {
    inputNamePrefix: String // e.g., 'status', 'event', etc.
  }

  connect() {
    this.newPhotoIndex = 0
    const selected = this.photoBoxTargets.find(el => el.dataset.thumbnailSelected === "true")
    if (selected) this.selectThumbnailByElement(selected)
  }

  triggerFileSelect() {
    this.fileInputTarget.click()
  }

  handleFiles(event) {
    const files = Array.from(event.target.files)
    files.forEach(file => {
      const reader = new FileReader()
      reader.onload = (e) => {
        const id = `new-${this.newPhotoIndex}`
        const box = this.createPreviewBox(e.target.result, id)
        this.previewWrapperTarget.insertBefore(box, this.previewWrapperTarget.lastElementChild)

        if (!this.thumbnailInputTarget.value) {
          this.selectThumbnailByElement(box)
        }

        // Create a hidden file input to submit
        const hiddenInput = document.createElement("input")
        hiddenInput.type = "file"
        // hiddenInput.name = "status[photos][]"
        hiddenInput.name = `${this.inputNamePrefixValue}[photos][]`

        const dt = new DataTransfer()
        dt.items.add(file)
        hiddenInput.files = dt.files

        this.inputsWrapperTarget.appendChild(hiddenInput)

        // Remove handler removes preview + input
        box.querySelector("button").addEventListener("click", (e) => {
          e.stopPropagation()
          box.remove()
          hiddenInput.remove()
          if (this.thumbnailInputTarget.value === id) {
            this.thumbnailInputTarget.value = ""
            this.clearHighlights()
          }
        })
      }

      reader.readAsDataURL(file)
      this.newPhotoIndex++
    })

    // Allow selecting the same file again
    this.fileInputTarget.value = ""
  }

  createPreviewBox(imageSrc, id) {
    const container = document.createElement("div")
    container.className = "position-relative border rounded overflow-hidden"
    container.style.width = "100px"
    container.style.height = "100px"
    container.style.cursor = "pointer"
    container.dataset.photoIdValue = id
    container.dataset.action = "click->photos#selectThumbnail"
    container.setAttribute("data-photos-target", "photoBox")

    const img = document.createElement("img")
    img.src = imageSrc
    img.className = "w-100 h-100 object-fit-cover"

    const border = document.createElement("div")
    border.className = "position-absolute top-0 start-0 w-100 h-100 border border-4 border-transparent"
    border.setAttribute("data-photos-target", "thumbnailHighlight")

    const removeBtn = document.createElement("button")
    removeBtn.type = "button"
    removeBtn.className = "btn-close text-bg-white position-absolute top-0 end-0 m-1"
    removeBtn.style.zIndex = "2"
    removeBtn.style.backgroundColor = "#FFFFFF"
    removeBtn.style.opacity = "1"

    container.appendChild(img)
    container.appendChild(border)
    container.appendChild(removeBtn)

    return container
  }

  selectThumbnail(event) {
    this.selectThumbnailByElement(event.currentTarget)
  }

  selectThumbnailByElement(el) {
    this.clearHighlights()
    this.thumbnailInputTarget.value = el.dataset.photoIdValue
    const highlight = el.querySelector("[data-photos-target='thumbnailHighlight']")
    highlight.classList.replace("border-transparent", "border-primary")
  }

  clearHighlights() {
    this.thumbnailHighlightTargets.forEach(el =>
      el.classList.replace("border-primary", "border-transparent")
    )
  }
}
